import { Component, OnInit } from '@angular/core';
import { ToastrService } from '@core/services/toastr.service';
import { Toast } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'gcc-toastr',
  template: `
    <div class="toastrs-container">
      <div *ngFor="let toast of toasts$ | async; trackBy: trackById">
        <alert
          [type]="toast.type"
          [dismissOnTimeout]="toast.timeout"
          [dismissible]="toast.dismissible"
          (onClosed)="onClosed(toast)"
        >
          <div class="message">{{ toast.message | translate: toast.translateParams }}</div>
        </alert>
      </div>
    </div>
  `,
  styles: [
    `
      .toastrs-container {
        position: fixed;
        width: 520px;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2000;
      }

      .message {
        word-break: break-all;
      }
    `
  ]
})
export class ToastrComponent implements OnInit {
  public toasts$: Observable<Toast[]>;

  constructor(private toastr: ToastrService) {}

  public ngOnInit(): void {
    this.toasts$ = this.toastr.toasts$;
  }

  public onClosed(toast: Toast) {
    this.toastr.closed(toast.id);
  }

  public trackById(_, toast: Toast): number {
    return toast.id;
  }
}
